import React, {useState} from 'react';
import BigHeader from '../../components/BigHeader';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Accordion from 'react-bootstrap/Accordion';
import "bootstrap/dist/css/bootstrap.min.css";
import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';

function ControlledCarousel({item}) {
    const [index, setIndex] = useState(0);
  
    const handleSelect = (selectedIndex , e) => {
        setIndex(selectedIndex);
    };
  
    return (
      <Carousel  interval={500000000}  activeIndex={index} onSelect={handleSelect} pause={'hover'} data-bs-theme="dark" >
        <Carousel.Item  > 
        <Container className="text-center" style={{minHeight: "550px"}}>
        <Container style={{maxHeight: "300px"}}>

        <Image  style={{width: 'auto',
height: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '20px', marginTop: '-100px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/wiki-general/engineering/cycle-1-deesign.png'} text="Second slide" />
                       </Container>

            <h3>{item[0].head}</h3>
            <p>{item[0].text}</p>
            </Container>

        </Carousel.Item>
        <Carousel.Item style={{alignItems:"center"}}> 
        <Container className="text-center" style={{minHeight: "550px"}}>
        <Container style={{maxHeight: "300px"}}>

        <Image  style={{width: 'auto',
height: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '20px', marginTop: '-100px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/wiki-general/engineering/cycle-2-build.png'} text="Second slide" />
                       </Container>
            <h3>{item[1].head}</h3>
            <p>{item[1].text}</p>
            </Container>

        </Carousel.Item>
        <Carousel.Item style={{alignItems:"center"}}> 
        <Container className="text-center" style={{minHeight: "550px"}}>
        <Container style={{maxHeight: "300px"}}>

        <Image  style={{width: 'auto',
height: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '20px', marginTop: '-100px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/wiki-general/engineering/cycle-3-test.png'} text="Second slide" />
                       </Container>
            <h3>{item[2].head}</h3>
            <p>{item[2].text}</p>
            </Container>

        </Carousel.Item>
        <Carousel.Item style={{alignItems:"center"}}> 
        <Container className="text-center" style={{minHeight: "550px"}}>
        <Container style={{maxHeight: "300px"}}>

        <Image  style={{width: 'auto',
height: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '20px', marginTop: '-100px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/wiki-general/engineering/cycle-4-learn.png'} text="Second slide" />
                       </Container>
            <h3>{item[3].head}</h3>
            <p>{item[3].text}</p>
            </Container>

        </Carousel.Item>
      </Carousel>
    );
  }

const Engineering = () => {
    const textBlocks = 
    [
        {
            header: "Iteration 1",
            image: null,
            isImageOnRight: true,
            text: "From the original pTE2900 plasmid vector, the generation of p\nELUB1 GFP-fusion producing plasmid required the insertion of the MoClo standard cloning site, with a linker region, on the C-terminus of the GFP sequence. This insertion region of 130 bp proved itself surprisingly problematic. Our first instinct was to insert the sequence through Gibson-based assembly, however the insertion sequence length deemed it too long to be synthesised as a primer pair, and too short to be synthesized as a gene fragment (by conventional ordering options). So we chose to generate the fragment in-house through polymerase chain assembly, and insert said fragment through Gibson assembly",
            dropdown:
            [ 
            {
                head: "Design",
                text: "From the original pTE2900 plasmid vector, the generation of p\nELUB1 GFP-fusion producing plasmid required the insertion of the MoClo standard cloning site, with a linker region, on the C-terminus of the GFP sequence. This insertion region of 130 bp proved itself surprisingly problematic. Our first instinct was to insert the sequence through Gibson-based assembly, however the insertion sequence length deemed it too long to be synthesised as a primer pair, and too short to be synthesized as a gene fragment (by conventional ordering options). So we chose to generate the fragment in-house through polymerase chain assembly, and insert said fragment through Gibson assembly"
            },
            {
                head: "Build",
                text: "hyperlink to PCA & Gibson protocol?\nThe insertion region of DNA was ordered as a set of 4 primers, designed with the aid of https://primerize.stanford.edu/. The primers were amplified together following the PCA protocol, while the backbone was separately amplified using primers overlapping with the ends of the insertion fragment. After DpnI digestion and PCR cleanup, the fragment was inserted into the backbone through the Gibson assembly protocol and cloned in *****E. coli.***** The cells were cultured and plasmids harvested by miniprep."
            },
            {
                head: "Test",
                text: "After 3 repeats with different PCR conditions, and with and without DpnI + PCR cleanup, we were unable to generate colonies with the correct final plasmid. Verified through PCR-based analysis using unique primers, and through whole plasmid sequencing."
            },
            {
                head: "Learn",
                text: "As we were getting a decent amount of colonies holding the kanamycin resistance gene, but without our gene of interest, we hypothesised that plasmid recircularisation was the main reason behind the colonies we were seeing. Perhaps this was also aided in the poor amplification of the insertion fragment, however by the second try, we had gotten good bands when analysing the PCR product through agarose gel electrophoresis after fine-tuning of the PCR conditions, which we found to be even more sensitive when using more than 2 primers in the PCR."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 2",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "So that we may have some kind of genetic machine to produce our proteins, we decided to generate a linear fragment which matches the utility of pTELUB1, through PCR amplification using unique primers encompassing the MoClo sites without the excision region. By performing this simpler method, we believed we could at least generate a working cloning vector while devising an alternative strategy to generate the whole plasmid."
            },
            {
                head: "Build",
                text: "Primers were designed against the pTE2900 plasmid, with overhangs including the GFP-linker region and BsaI sites for cloning. PCR was performed to amplify the 6000bp fragment, and DpnI was used to digest the template plasmid."
            },
            {
                head: "Test",
                text: "Gel electrophoresis of PCR product confirmed fragments of the correct size, from this result we decided to clone a few of our candidate proteins via golden gate cloning. Sequencing of our miniprep product confirmed the presence of our final expression plasmid. SDS-PAGE confirmed the IPTG induced production of our cloned protein, confirming the correct activity of our vector."
            },
            {
                head: "Learn",
                text: "From this experiment we obtained a working cloning vector for our future experiments, however the linearised nature of the fragment vector makes it less ideal for storing and sharing, compared to a circular plasmid. We confirm that the genetic design itself is feasible, and we continue to work on alterative cloning strategies while continuing with our experimental pipeline."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 3",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "We decided to avoid generating the fragment through PCR, and instead devised two alternative strategies:\n1. We order the whole GFP-construct region of the plasmid as a gene fragment (so that it is large enough to satisfy Twist bioscience’s conditions for synthesis) and otherwise perform cloning through Gibson assembly as planned. We avoided this originally as synthesis of a large fragment is more expensive than as primers.\n2. We synthesise the whole insert fragment as a pair of overlapping oversized primers (~90bp) and otherwise amplify through PCR and Gibson assembly as normal. We originally avoided this due to the proposed instability of long, single-stranded DNA oligos, however decided it may be worth trying, as the option to do so is available through IDT."
            },
            {
                head: "Build",
                text: "Cloning was conducted as per the design principle, transformed into TOP10 E. coli and purified through miniprep from multiple colonies."
            },
            {
                head: "Test",
                text: "Agarose gel electrophoresis results showed bands of the correct size. While sequencing showed a slightly higher error rate for the colonies from strategy 2, we had viable correct results from both strategies."
            },
            {
                head: "Learn",
                text: "We tested and verified multiple slightly different cloning strategies. While slightly higher in cost, we conclude that ordering insertion fragments as whole fragments is more effective and time efficient."
            }
        ],
            backgroundColor: null
        },
    ]

    const phage = 
    [
        {
            header: "Iteration 1 - Devising a method for assessing phage capture",
            image: null,
            isImageOnRight: true,
            text: "From the original pTE2900 plasmid vector, the generation of p\nELUB1 GFP-fusion producing plasmid required the insertion of the MoClo standard cloning site, with a linker region, on the C-terminus of the GFP sequence. This insertion region of 130 bp proved itself surprisingly problematic. Our first instinct was to insert the sequence through Gibson-based assembly, however the insertion sequence length deemed it too long to be synthesised as a primer pair, and too short to be synthesized as a gene fragment (by conventional ordering options). So we chose to generate the fragment in-house through polymerase chain assembly, and insert said fragment through Gibson assembly",
            dropdown:
            [ 
            {
                head: "Design",
                text: "Through our literature searches, we could not find any established protocol for measuring the capture of phages in solution, so we set about to develop our own.\nIn the first instance, we expanded upon the standard plaque assay: a key tool in phage infection assays, but with a layer of mucin which acts as a barrier in an attempt to mimic how things may happen in the context of the human epithelium with our own viruses, without the friction of course!\nWe hypothesised that the diffusion of virions within the mucin may cause some issues quantifying the plaques, so we tested different layouts and concentrations"
            },
            {
                head: "Build",
                text: "Bacterial lawns were formed by inoculating LB-Agar with wild-type E. coli before plating. Agar was set in 10 cm square petri dishes for normal serial titer plaque assays, and 2cm 12 well plates for individually assessing phage titers. Set agar wells had different volumes of different mucin concentrations applied over the top, as to coat the agar surface."
            },
            {
                head: "Test",
                text: "T4 phage at different dilutions were applied to the bacterial lawns from on top of the mucin layer, after incubation, the formations of plaque was measured, both before and after washing of the mucin layer.\nAs hypothesised, the diffusion of virions within and across the mucin gel dispersed plaque formation and made them less distinct. Even with individual titers in small wells, the distinction of plaques was near impossible."
            },
            {
                head: "Learn",
                text: "This method did not allow us to quantify the phage infection, we needed more localisation of plaques."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 2",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "After the results of the previous test cycle, we wanted to test if we could mix the phages in mucin dilutions before hand and achieve viable plaques. For this we performed a standard plaque assay, but with the phages initially serially diluted in various mucin compositions before application on the agar."
            },
            {
                head: "Build",
                text: "Various mucin compositions were devised, and our model phages serially diluted in these. Standard plaque assays were performed using these dilutions."
            },
            {
                head: "Test",
                text: "Interestingly, we found that mucin itself had a mild antimicrobial effect, as seen by lysis of E. coli cells, localised in the areas of mucin application. "
            },
            {
                head: "Learn",
                text: "This made determination of phage-induced lysis plaques extremely challenging. We found from this that future iterations should keep the mucin incorporated within the agar lawn, so that its presence may be universal across samples, though it will be less accurate of a model for what may actually happen in vivo."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 3",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "This protocol was designed with the aim of creating a controlled environment for phage diffusion such that we could extract quantifiable measurements from the experiment.\nFrom the previous trials it was evident that a separate solid layer containing mucin between the phage and bacteria would localise the diffusion of phages as well as minimise the effect of mucin on bacterial cells. However, it needed to allow phages to diffuse through. Our hypothesis was that mucin acts as a diffusion barrier for phage infection."
            },
            {
                head: "Build",
                text: "We opted to create this layer by mixing various mucin dilutions in soft agar (MMBA) and testing the thickness of this layer as another variable to establish a range of conditions that permitted phage diffusion. Hence,  the two variables, mucin concentration in MMBA and the thickness of the layer were tested in a 12-well plate, with successive rows representing the thickness variable, and columns corresponding to mucin concentration."
            },
            {
                head: "Test",
                text: "We tested T4 phage concentrations ranging from 10^-1 to 10^-2 on mucin-soft agar layer sizes ranging from 1ml to 0.3ml with mucin concentrations ranging from 25gm/ml to 0.25mg/ml.\nPlaques were observed for plates inoculated with high phage concentrations (10^-1 to 10^-3). more plaques were observed in wells containing a lesser concentration of mucin as well as a thinner layer of mucin-soft agar, as hypothesized."
            },
            {
                head: "Learn",
                text: "The success of this method implied that we could test the ability of our augmented mucin in terms of reducing phage infection. The mucin can also potentially be substituted by T4 binding proteins to test the results of in-silico protein modelling. Knowing the thresholds of the parameters of thickness and concentration also allows for investigating the impact of smaller changes in these parameters.\nThere are however a few drawbacks, the commercial mucin we were working with is not sterile, and shows contaminant growth within 24 hrs of being hydrated. Even though the plaques are strictly restricted to the bottom layer of bacterial cells, the contaminants in the mucin may be a confounding factor to the whole experiment. The solution to this is sterilizing the mucin, however it requires certain equipment that we did not have access to."
            }
            ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 4 - Testing RFdiffusion protein binding",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "Although a less close-to-life method of assessing the interactions, we decided that assessing the direct binding itself was good enough for our proof of concept, nonetheless we required a quick and cost effective screening method for our library of proteins (unlike more sophisticated methods such as isothermal titration calorimetry). First we attempted a PseudoELISA type interaction assessment."
            },
            {
                head: "Build",
                text: "ELISA plates were coated with our designed binding proteins, and incubated with solutions of T4 bacteriophage. The supernatant was then collected and titered in a plaque assay, to measure if there was any decrease in available phage in solution."
            },
            {
                head: "Test",
                text: "No significant difference was seen in the formation of plaques between the test and control samples."
            },
            {
                head: "Learn",
                text: "We hypothesised that the 2D surface of adhered protein was not enough to capture a significant amount of phage. While this might be improved by drastically reducing the amount of phage in the solution (by significant dilution of the phage solution), it still would be a less than ideal representation of our model which relies on the binding of multiple binders per viral particle, we applied this to our following iteration."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 5",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "Working from the learning of the previous iteration, we decided that it is vital that we allow the binding to occur in solution to enable multibinding of proteins to phage. For this we adjusted a pull-down protein interaction assay to assess phages."
            },
            {
                head: "Build",
                text: "Diluted phage solutions were incubated with his-tagged binding proteins first at a molecular ratio of around 100 : 1 protein to phage, and 20,000 : 1 on the following iteration. Incubated mixture was then further incubated with Ni-NTA affinity purification agarose and placed in a gravity flow column. The first flowthrough, neutral buffer wash, and final elute were collected, and each titered on a plaque assay to measure available phage. These were compared to controls of phage on its own or incubated with sfGFP."
            },
            {
                head: "Test",
                text: "3 test samples showed a slight reduction of phage plaques in the flowthrough at the 100 : 1 ratio, but the difference was extremely faint so we repeated the process for the 3 samples with a higher ratio of protein to phage. In this repeat we saw a significant increase in phage plaques for the elute solution, suggesting that a non negligible amount of phages were being caught and retained by the proteins."
            },
            {
                head: "Learn",
                text: "The co-incubation in solution seems to work significantly better and we were able to actually identify binding proteins, which we were unsure that we even had managed to generate. Nonetheless while significant, the change was still small and we hypothesise that alongside the concentration ratio of protein to phage, the total amount of phage in solution could be further reduced. For the first repeat we started with 200 uL of phage solution at around 1 x10^9 PFU/mL concentration and for the second we used 200 uL of phage at around 1 x 10^7 PFU/ml concentration, but we learned that perhaps an even lower concentration may be more adequate."
            }
        ],
            backgroundColor: null
        },
    ]

    const lubricant = 
    [
        {
            header: "Iteration 1",
            image: null,
            isImageOnRight: true,
            text: "The initial iteration of creating a prototype for our lubricant was done according to a standard mucin dilution protocol. ",
            dropdown:
            [ 
            {
                head: "Design",
                text: "Through our literature searches, we could not find any established protocol for measuring the capture of phages in solution, so we set about to develop our own.\nIn the first instance, we expanded upon the standard plaque assay: a key tool in phage infection assays, but with a layer of mucin which acts as a barrier in an attempt to mimic how things may happen in the context of the human epithelium with our own viruses, without the friction of course!\nWe hypothesised that the diffusion of virions within the mucin may cause some issues quantifying the plaques, so we tested different layouts and concentrations"
            },
            {
                head: "Build",
                text: "Mucin from porcine stomach in its powdered form was serially diluted in PBS with a concentration ranging from 50mg/ml to 0.05gm/ml. "
            },
            {
                head: "Test",
                text: "Mucin from porcine stomach in its powdered form was serially diluted in PBS with a concentration ranging from 50mg/ml to 0.05gm/ml. "
            },
            {
                head: "Learn",
                text: "The higher concentrations of mucin made the solution sheer thickening or non-Newtonian. This is not the consistency we wanted."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 2",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "We found literature on an acid induced solid-gel transition of mucin, and decided to test the effects of acidity on the properties of our mucin. We also thought that having an acidic product may have better compatibility with the vaginal acidic conditions."
            },
            {
                head: "Build",
                text: "We diluted the porcine mucin powder according to protocol in succinic acid all the way to pH 2.1. This did not induce a gel transition but rather made the solution emit a putrid smell."
            },
            {
                head: "Test",
                text: "We diluted the porcine mucin powder according to protocol in succinic acid all the way to pH 2.1. This did not induce a gel transition but rather made the solution emit a putrid smell."
            },
            {
                head: "Learn",
                text: "The paper we drew our inspiration from used freshly harvested mucin from porcine stomachs and it also mentioned that protease treatment in the preparation of commercially available mucin degrades the glycoproteins such that rheological properties deviate from those of untreated mucus. We believe that this is why we were not able to replicate the gel transition of mucin. a"
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 3",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "We wanted to overcome the non Newtonian behaviour of or mucin dilutions. Our hypothesis was diluting the mucin in a more viscous liquid may overcome the sheer thickening property. Glycerol seemed to be the most evident liquid to try as it was cheap, widely used in our lab and viscous."
            },
            {
                head: "Build",
                text: "We serially diluted mucin in glycerol and it seemed to mix with it way more easily than PBS or succinic acid. "
            },
            {
                head: "Test",
                text: "We serially diluted mucin in glycerol and it seemed to mix with it way more easily than PBS or succinic acid. "
            },
            {
                head: "Learn",
                text: "Diluting mucin in glycerol seems to be the right direction for our lubricant consistency. The ease of dilution may be influenced by interactions between mucin and glycerol which may be a confounding factor. "
            }
        ],
            backgroundColor: null
        },
    ]

    const silico = [
        {
            header: "Iteration 1",
            image: null,
            isImageOnRight: true,
            text: "The initial iteration of creating a prototype for our lubricant was done according to a standard mucin dilution protocol. ",
            dropdown:
            [ 
            {
                head: "Design",
                text: "At first, we attempt to run the RFdiffusion code locally on our personal GPU. The source code was obtained from Baker lab Github and code was run. However we encountered many issues, mainly related to code environment and GPU driver compatibility, so we looked to explore other options and tools."
            },
            {
                head: "Build",
                text: "We decided to avoid local running of the code and ran the code using a Colab notebook."
            },
            {
                head: "Test",
                text: "Unfortunately, this also presented challenges, particularly when running Binders for the HPV major capsid protein."
            },
            {
                head: "Learn",
                text: "In the learning phase, we realized that the structure of the protein needed to be reduced after attempting to use the Colab notebook. This insight prompted us to make adjustments to our approach and explore protein structure reduction techniques in the subsequent iteration."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 2",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "In the second iteration of the design phase, we focused on refining our approach to selecting hotspots. This adjustment was inspired by our re-reading of the RFdiffusion GitHub repository and consultation with Dr. Courbet. We aimed to enhance the accuracy of our hotspot selection criteria."
            },
            {
                head: "Build",
                text: "In the building phase, we modified our code to implement the refined hotspot selection approach. We continued to explore methods for reducing protein structure size, aligning with the insights gained from our experts."
            },
            {
                head: "Test",
                text: "During testing, we utilized the new hotspot selection criteria and evaluated our code on a range of protein structures. This iteration aimed to enhance the accuracy of our predictions based on our refined approach."
            },
            {
                head: "Learn",
                text: "In the learning phase, we gathered insights into more effective hotspot selection, driven by expert advice and our improved code. These lessons became instrumental in the subsequent iteration."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 3",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "In the third iteration of the design phase, we decided to explore in-silico docking programs to further improve our binding predictions. This decision was influenced by the knowledge we gained from our previous iteration, where we enhanced hotspot selection."
            },
            {
                head: "Build",
                text: "In the building phase, we downloaded and set up HDOCK, enabling us to parallelize the docking process and improve efficiency. This aligns with our goal of streamlining the selection of target structures."
            },
            {
                head: "Test",
                text: "Testing involved running HDOCK on a large number of protein structures to filter the results effectively. This step aimed to streamline the selection of target structures based on our refined approach."
            },
            {
                head: "Learn",
                text: "In the learning phase, we gathered valuable experience in using HDOCK and understood its benefits, such as speed and local availability. This knowledge enabled us to make informed decisions about our approach, building on the lessons from previous iterations.\nThese iterations demonstrate our team's dedication to continuous improvement and learning throughout the Design, Build, Test, and Learn phases, ultimately leading to a successful engineering outcome in our life science project."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 4",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "In the design phase, we sought to overcome the issues we faced while using the RFdiffusion Colab notebook, which were primarily related to the notebook's inability to handle large protein structures. To address this, we had to redesign our approach and explore ways to work with smaller protein structures that the notebook could handle."
            },
            {
                head: "Build",
                text: "During the building phase, we revisited the notebook's documentation and took into account the limitations imposed by larger protein structures. This led us to experiment with smaller proteins and different prompts, as well as various parameters to improve compatibility with the notebook."
            },
            {
                head: "Test",
                text: "In the testing phase, we repeatedly ran the RFdiffusion Colab notebook with the downsized protein structures and various prompts. We aimed to assess whether these adjustments resolved the issues we initially encountered. Through these tests, we discovered that the notebook was more amenable to smaller protein structures, and the specificity of the prompts played a critical role in its effectiveness."
            },
            {
                head: "Learn",
                text: "Through testing and exploration, we gained valuable insights into how the RFdiffusion Colab notebook performed with smaller structures and different prompts. This knowledge enabled us to understand the notebook's limitations, as well as the importance of adapting the structure size and prompt to achieve successful results. These insights informed our approach in the subsequent iteration, ultimately leading to a more effective workflow in our life science project."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 5",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "In the third iteration of our project, we delved deeper into the issue of reducing protein structure size. Our aim was to optimize this process to make it more efficient. To do so, we explored various strategies, including taking only the outermost (surface) residues of the target and deleting any residues that exceeded a certain threshold distance from the hotspots we selected."
            },
            {
                head: "Build",
                text: "The building phase involved implementing these size-reduction strategies in our project. We adjusted our code to incorporate the new criteria for reducing protein structures. This phase also included consulting external sources for validation and best practices."
            },
            {
                head: "Test",
                text: "During the testing phase, we ran our modified code using the newly implemented size reduction strategies. We evaluated the performance of these strategies to ensure that they effectively reduced the protein structures without compromising the integrity of the project."
            },
            {
                head: "Learn",
                text: "Through testing, we learned that these size-reduction strategies were beneficial in optimizing our approach. We also sought expert guidance to validate our approach. Specifically, we contacted Alexis Courbet from Baker Lab at the University of Washington, who provided crucial insights. He assured us that reducing the size using a threshold distance was an acceptable and valid practice, further validating our methodology. Additionally, we discovered that the RFdiffusion GitHub repository also recommended size reduction in general. These insights consolidated our understanding of the importance of size reduction and informed our approach moving forward."
            }
        ],
            backgroundColor: null
        },
        {
            text: "",
            header: "Iteration 6",
            image: null,
            isImageOnRight: true,
            dropdown:
            [ 
            {
                head: "Design",
                text: "In our project, after obtaining a substantial number of results, we needed to devise a method to rank the best among them. The volume of data was impractical to test experimentally. To tackle this challenge, we explored the concept of the i_pae value (Predicted Aligned Error) derived from the AlphaFold validating step. Although originally intended to predict confidence in folding sequences, it was considered as a potential indicator of binding quality. However, it showed limited variability, making it less suitable for our needs.\nTo address this issue, we decided to search for a tool that could perform in-silico binding assessment effectively. We aimed to streamline the process and reduce the number of sequences for further analysis."
            },
            {
                head: "Build",
                text: "During the building phase, we commenced our quest to find an appropriate tool for in-silico binding assessment. Our exploration led us to the CASP-CAPRI collaboration, a well-known protein docking competition. This event involved predicting the structure of protein-protein complexes, and the results were made publicly available for evaluation. To select a tool, we began by examining the top-ranking servers in the CASP-CAPRI competition to gauge their performance and reliability."
            },
            {
                head: "Test",
                text: "The testing phase involved a careful evaluation of potential tools for in-silico binding assessment. After examining various options, we ultimately chose HDOCK for our project. We based this decision on several compelling reasons:\nSpeed: HDOCK was known for its efficiency due to its fast rigid-body docking algorithm that utilized FFT.\nLocal Availability: Unlike most other tools that are web-hosted, HDOCK could be downloaded and run locally on our machines, offering greater control.\nParallelization: To enhance efficiency, we parallelized the docking process using the multiprocessing Python library.\nProven Performance: HDOCK's track record was impressive, with a first-place ranking in the CASP-CAPRI11 competition. It was also used as part of the judging process in the latest CASP-CAPRI competition, demonstrating its reliability.\nOur choice of HDOCK, while introducing higher variability, proved to be effective for filtering and evaluating our results. It allowed us to filter out approximately 50% of the files, and the i_pae value became a valuable criterion in our assessment. Additionally, we explored the option of selecting one sequence for each target to refine our analysis."
            },
            {
                head: "Learn",
                text: "Through this process, we learned the importance of selecting the right tool for in-silico binding assessment and how the i_pae value, despite its limitations, could be a useful indicator for our project. Our decision to use HDOCK was validated by its speed, local availability, parallelization capabilities, and its proven track record in the CASP-CAPRI competitions. This selection marked a significant step in streamlining our project and improving the efficiency of our in-silico binding assessment. In this phase, we also recognized the value of taking an organized and systematic approach to tool selection and evaluation to achieve better outcomes in our life science project."
            }
        ],
            backgroundColor: null
        },
    ]
    return (
        <div>
                <BigHeader headerText={'Engineering'} backgroundImage={'https://static.igem.wiki/teams/4602/wiki/images/images/background.jpg'}/>
                <p style={{paddingTop: '25px', paddingBottom: '25px', paddingLeft: '100px', paddingRight: '100px'}} className="fs-4 text-center">Bioengineering, genetic engineering, synthetic biology….. We often refer to practices within the life sciences using more mechanical and engineering terms. This relies not in the use of biology within  engineering practices, though sometimes this is the case, but on the application of the engineering design-test cycle within biology. Here we annotate our process of iterative optimisation through our project, both in biological engineering and of our experimental process.</p>
                <Tabs
                    defaultActiveKey="genetic"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                    justify
                    >
                    <Tab eventKey="genetic" title="Genetic">
                    <Accordion defaultActiveKey="0">

                                {textBlocks.map((item, test) => ( 
                        
                        <Accordion.Item eventKey={String(test)}>
                    <Accordion.Header>{item.header}</Accordion.Header>
                    <Accordion.Body>
                    <ControlledCarousel item={item.dropdown}/>
                                        </Accordion.Body>
                    </Accordion.Item>
                    
                    ))}
                    </Accordion>


    </Tab>
      <Tab eventKey="insilico" title="In-Silico">
      <Accordion>
            {silico.map((item, test) => ( 
                
            <Accordion.Item eventKey={String(test)}>
                <Accordion.Header>{item.header}</Accordion.Header>
                    <Accordion.Body>
                        <ControlledCarousel item={item.dropdown}/>
                    </Accordion.Body>
                </Accordion.Item>
            ))}
            </Accordion>
      </Tab>
      <Tab eventKey="experimental" title="Experimental">
            <Tabs
                defaultActiveKey="phage"
                id="uncontrolled-tab-example"
                className="mb-3"
                justify
                > 
                        <Tab eventKey="phage" title="Phage infection">
                        <Accordion>

                        {phage.map((item, test) => ( 
                            
                            <Accordion.Item eventKey={String(test)}>
                        <Accordion.Header>{item.header}</Accordion.Header>
                        <Accordion.Body>
                        <ControlledCarousel item={item.dropdown}/>
                                            </Accordion.Body>
                        </Accordion.Item>

                        ))}
                        </Accordion>
                    </Tab>
                        <Tab eventKey="lubricant" title="Lubricant composition">
                        <Accordion>

                        {lubricant.map((item, test) => ( 
                            
                            <Accordion.Item eventKey={String(test)}>
                        <Accordion.Header>{item.header}</Accordion.Header>
                        <Accordion.Body>
                        <ControlledCarousel item={item.dropdown}/>
                                            </Accordion.Body>
                        </Accordion.Item>

                        ))}
                        </Accordion>
                    </Tab>
            </Tabs>

        </Tab>
    </Tabs>
                    </div>
    )
}
export default Engineering;
